export const ADVISOR_SIDE_NAV_EXPANDED_SESSION_STORAGE_KEY = 'advisor-side-nav-open';
